module.exports = __webpack_public_path__ + "static/media/USBInput.995bd956.svg";